export const tiposModulo = [
    { value: 1, text: 'SEBRAETEC' },
    { value: 2, text: 'SGF' },
    { value: 3, text: 'TODOS' }
]